/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyPalletBase } from "./ShopifyPalletBase";
import {
  ShopifyPalletBaseFromJSON,
  ShopifyPalletBaseFromJSONTyped,
  ShopifyPalletBaseToJSON,
  ShopifyPalletBaseToJSONTyped,
} from "./ShopifyPalletBase";

/**
 *
 * @export
 * @interface ShopifyPalletizationConfig
 */
export interface ShopifyPalletizationConfig {
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPalletizationConfig
   */
  enabled: boolean;
  /**
   *
   * @type {number}
   * @memberof ShopifyPalletizationConfig
   */
  maxPalletHeightInches: number;
  /**
   *
   * @type {number}
   * @memberof ShopifyPalletizationConfig
   */
  maxPalletWeightPounds: number;
  /**
   *
   * @type {number}
   * @memberof ShopifyPalletizationConfig
   */
  palletTareWeightPounds: number;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPalletizationConfig
   */
  itemsStackOnEachOther: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyPalletizationConfig
   */
  palletsAreStackable: boolean;
  /**
   *
   * @type {Array<ShopifyPalletBase>}
   * @memberof ShopifyPalletizationConfig
   */
  palletBases: Array<ShopifyPalletBase>;
}

/**
 * Check if a given object implements the ShopifyPalletizationConfig interface.
 */
export function instanceOfShopifyPalletizationConfig(
  value: object,
): value is ShopifyPalletizationConfig {
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  if (
    !("maxPalletHeightInches" in value) ||
    value["maxPalletHeightInches"] === undefined
  )
    return false;
  if (
    !("maxPalletWeightPounds" in value) ||
    value["maxPalletWeightPounds"] === undefined
  )
    return false;
  if (
    !("palletTareWeightPounds" in value) ||
    value["palletTareWeightPounds"] === undefined
  )
    return false;
  if (
    !("itemsStackOnEachOther" in value) ||
    value["itemsStackOnEachOther"] === undefined
  )
    return false;
  if (
    !("palletsAreStackable" in value) ||
    value["palletsAreStackable"] === undefined
  )
    return false;
  if (!("palletBases" in value) || value["palletBases"] === undefined)
    return false;
  return true;
}

export function ShopifyPalletizationConfigFromJSON(
  json: any,
): ShopifyPalletizationConfig {
  return ShopifyPalletizationConfigFromJSONTyped(json, false);
}

export function ShopifyPalletizationConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyPalletizationConfig {
  if (json == null) {
    return json;
  }
  return {
    enabled: json["enabled"],
    maxPalletHeightInches: json["maxPalletHeightInches"],
    maxPalletWeightPounds: json["maxPalletWeightPounds"],
    palletTareWeightPounds: json["palletTareWeightPounds"],
    itemsStackOnEachOther: json["itemsStackOnEachOther"],
    palletsAreStackable: json["palletsAreStackable"],
    palletBases: (json["palletBases"] as Array<any>).map(
      ShopifyPalletBaseFromJSON,
    ),
  };
}

export function ShopifyPalletizationConfigToJSON(
  json: any,
): ShopifyPalletizationConfig {
  return ShopifyPalletizationConfigToJSONTyped(json, false);
}

export function ShopifyPalletizationConfigToJSONTyped(
  value?: ShopifyPalletizationConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enabled: value["enabled"],
    maxPalletHeightInches: value["maxPalletHeightInches"],
    maxPalletWeightPounds: value["maxPalletWeightPounds"],
    palletTareWeightPounds: value["palletTareWeightPounds"],
    itemsStackOnEachOther: value["itemsStackOnEachOther"],
    palletsAreStackable: value["palletsAreStackable"],
    palletBases: (value["palletBases"] as Array<any>).map(
      ShopifyPalletBaseToJSON,
    ),
  };
}
